import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f5aabf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "megamenu-location-groups__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MegamenuLocationGroup = _resolveComponent("MegamenuLocationGroup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["megamenu-location-groups", { flex: _ctx.locationGroup.locationName === 'group' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["megamenu-location-group__title", {
          'h-8': !_ctx.locationGroup.locationName,
        }])
      }, _toDisplayString(_ctx.locationGroup.locationName
            ? _ctx.$t(
                `location.${_ctx.camelCaseToSnakeCase(
                  _ctx.locationGroup.locationName
                )}.label`
              )
            : ''), 3),
      _createVNode(_component_MegamenuLocationGroup, {
        navigationTree: _ctx.locationGroup.navigationTree,
        showChildren: _ctx.showChildren(_ctx.locationGroup.locationName),
        onClickLocationLink: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickLocationLink', $event)))
      }, null, 8, ["navigationTree", "showChildren"])
    ])
  ], 2))
}